import React, {
  useState, useEffect,
} from 'react';
import { func } from 'prop-types';
import cookies from 'react-cookies';
import { Box, Button as MuiButton } from '@material-ui/core';
import { Typography, useError } from '@avon/component-library';
import { makeStyles, useTheme } from '@material-ui/styles';
import AvonTooltip from '../AvonTooltip';
import { getOptOutConfig, getOptOut, setOptOut } from '../../utils/api/endpoints';

import successSvg from '../../styles/assets/success.svg';
import warnSvg from '../../styles/assets/warn.svg';
import checkSvg from '../../styles/assets/checkmark.svg';
import closeSvg from '../../styles/assets/closemark.svg';
import IOSSwitch from '../IOSSwitch';

import { isMobile } from '../../utils/getDeviceType';

const useStyles = makeStyles(theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
  },
  titleBox: {
    height: isMobile() ? 44 : 80,
  },
  topbar: {
    zIndex: 102,
    top: 0,
    position: 'sticky',
  },
  toolbar: {
    display: 'flex',
    zIndex: 102,
    width: '100%',
    textAlign: 'justify',
    textAlignLast: 'justify',
    paddingTop: theme.spacing(2.5),
    paddingLeft: styleProps => (styleProps.language === 'ar' ? theme.spacing(3) : theme.spacing(1)),
    paddingRight: styleProps => (styleProps.language === 'ar' ? theme.spacing(1) : theme.spacing(3)),
    backgroundColor: theme.palette.colors.white,
    '& span': {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: 16,
    },
  },
  gridButton1: {
    minHeight: theme.spacing(3),
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 0,
    wordBreak: 'break-word',
    color: theme.palette.colors.textDark,
  },
  gridButton2: {
    minHeight: theme.spacing(3),
    width: 'auto',
    paddingTop: 0,
    paddingBottom: 0,
    wordBreak: 'break-word',
    color: theme.palette.colors.corePink,
    '&:hover': {
      backgroundColor: 'rgba(24, 24, 24, 0.08)',
    },
  },
}));

const OptOut = ({ callApi, redirectTo }) => {
  const theme = useTheme();
  const cls = useStyles();
  const { setError, cleanToastBanner } = useError();

  const language = cookies.load('langCd');

  // const [optOutEnabled, setOptOutEnabled] = useState(false);
  const [optOutConfig, setOptOutConfig] = useState();
  const [optOutData, setOptOutData] = useState();

  // get the opt out config
  useEffect(() => {
    const getConfig = async () => {
      try {
        await callApi(getOptOutConfig()).then((res) => {
          setOptOutConfig(res.jsonObject);
        });

        cleanToastBanner();
        return true;
      } catch (e) {
        setError(e.error);
        return false;
      }
    };

    getConfig();
  }, []);

  const getContent = async () => {
    try {
      await callApi(getOptOut()).then((res) => {
        setOptOutData(res);
      });

      cleanToastBanner();
      return true;
    } catch (e) {
      setError(e.error);
      return false;
    }
  };

  // get the opt out info
  useEffect(() => {
    getContent();
  }, []);

  const {
    listEnable = true,
    optOutEnable = false,
    outOfOfficeEnable = true,
    loginEnable = true,
    statusEnable = true,
    eligiEnable = false,
  } = optOutData || {};

  const [optOutEnabled, setOptOutEnabled] = useState(optOutEnable);

  useEffect(() => { }, [optOutEnabled, optOutData]);

  const toggleOptOut = async () => {
    const status = !optOutEnabled;
    try {
      await callApi(setOptOut(status));
      setOptOutEnabled(status);
      getContent();
      cleanToastBanner();
      return true;
    } catch (e) {
      setError(e.error);
      return false;
    }
  };

  const {
    title, header = [], description = [], eligibleHeader, eligibleCriteria = [], optout = 'Opt Out', optOutContent, learnMore = 'LEARN MORE',
  } = optOutConfig || {};

  return optOutConfig && optOutData ? (
    <Box className={cls.main}>
      <Box className={cls.topbar}>
        <Box
          data-testid="toolbar"
          id="admin-pma-toolbar"
          component="div"
          className={cls.toolbar}
        >
          {isMobile() ? (
            <MuiButton
              className={cls.gridButton1}
              id="back-home-button-pma"
              onClick={() => redirectTo({
                type: 'home', subType: null, hasFooter: false, params: null,
              })}
            >
              <svg width="60" height="44" viewBox="0 0 60 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M23.3872 15.2096C23.7795 14.9047 24.3467 14.9324 24.7072 15.293L24.7904 15.3872C25.0953 15.7795 25.0676 16.3467 24.707 16.7072L20.4132 21H32C32.5523 21 33 21.4477 33 22C33 22.5128 32.614 22.9355 32.1166 22.9933L32 23H20.4167L24.7071 27.2916L24.7903 27.3858C25.0953 27.7781 25.0676 28.3453 24.7071 28.7058C24.3166 29.0963 23.6834 29.0963 23.2929 28.7058L17.3241 22.737C17.1249 22.5542 17 22.2917 17 22C17 21.9992 17 21.9983 17 21.9975C17.0003 21.7419 17.098 21.4865 17.293 21.2915L23.293 15.2928L23.3872 15.2096Z" fill="#181818" />
              </svg>

              {/* {toolBarObject.close} */}
            </MuiButton>
          ) : null}

          <Typography
            variant="h4"
            style={{
              alignSelf: isMobile() ? 'center' : 'unset',
              flexGrow: 1,
              fontSize: '16px',
              margin: isMobile() ? 'unset' : 24,
              // eslint-disable-next-line
              textAlignLast: isMobile() ? 'center' : language === 'ar' ? 'right' :'left',
            }}
          >
            {title}
          </Typography>
          <MuiButton
            color="secondary"
            variant="contained"
            className={cls.gridButton2}
            id="pma-toolbar-right-button"
          />
        </Box>
      </Box>
      <Box id="content" style={{ width: isMobile() ? '100%' : 468, alignSelf: 'center' }}>
        <Box>
          <Box textAlign="center" mt={isMobile() ? '22px' : '25px'}>
            <img alt="icon" src={!eligiEnable ? warnSvg : successSvg} />
          </Box>
          <Typography variant="h4" style={{ textAlign: 'center', marginTop: isMobile() ? '14px' : '24px' }}>
            {!eligiEnable ? header[1] : header[0]}
          </Typography>
          <Typography variant="body2" style={{ textAlign: 'center', marginTop: 12 }}>
            {!eligiEnable ? description[1] : description[0]}
          </Typography>
        </Box>
        <Box id="criterias" mt="24px" p="12px" style={{ background: '#F6F9F9' }}>
          <Typography variant="body1" style={{ fontSize: isMobile() ? 14 : 18, fontWeight: 600 }}>{eligibleHeader}</Typography>
          <Box style={{ display: 'flex' }} mt="10px">
            <img alt="criteriaIcon" src={listEnable ? checkSvg : closeSvg} />
            <Typography varint="body1" style={{ margin: '2px 2px 2px 6px', color: listEnable ? '#1A8282' : '#851168' }}>{eligibleCriteria[0]}</Typography>
          </Box>
          <Box style={{ display: 'flex', margin: '2px 0 2px 0' }}>
            <img alt="criteriaIcon" src={!optOutEnable ? checkSvg : closeSvg} />
            <Typography varint="body1" style={{ margin: '2px 2px 2px 6px', color: !optOutEnable ? '#1A8282' : '#851168' }}>{eligibleCriteria[1]}</Typography>
          </Box>
          <Box style={{ display: 'flex', margin: '2px 0 2px 0' }}>
            <img alt="criteriaIcon" src={!outOfOfficeEnable ? checkSvg : closeSvg} />
            <Typography varint="body1" style={{ margin: '2px 2px 2px 6px', color: !outOfOfficeEnable ? '#1A8282' : '#851168' }}>{eligibleCriteria[2]}</Typography>
          </Box>
          <Box style={{ display: 'flex', margin: '2px 0 2px 0' }}>
            <img alt="criteriaIcon" src={loginEnable ? checkSvg : closeSvg} />
            <Typography varint="body1" style={{ margin: '2px 2px 2px 6px', color: loginEnable ? '#1A8282' : '#851168' }}>{eligibleCriteria[3]}</Typography>
          </Box>
          <Box style={{ display: 'flex', margin: '2px 0 2px 0' }}>
            <img alt="criteriaIcon" src={statusEnable ? checkSvg : closeSvg} />
            <Typography varint="body1" style={{ margin: '2px 2px 2px 6px', color: statusEnable ? '#1A8282' : '#851168' }}>{eligibleCriteria[4]}</Typography>
          </Box>
        </Box>
        <Box key="optOutSwitch">
          <Box
            fontFamily="Montserrat-Medium"
            fontSize="12px"
            color="#546264"
          >
            <Box variant="body1" color="textPrimary" align="left" display="flex" alignItems="center">
              <Box style={{ margin: '6px 8px 3px 27px' }}>{optout}</Box>
              <Box
                pt="4px"
                component="span"
                mr={language === 'ar' ? 'unset' : 2}
                ml={language === 'ar' ? 2 : 'unset'}
                style={{ cursor: 'pointer' }}
              >
                <AvonTooltip
                  position="top"
                  trigger="click"
                  arrow
                  tipMsg={optOutContent}
                  theme="light"
                  interactive
                  language={language}
                  showDissmiss
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12.9933 13.1166C12.9355 13.614 12.5128 14 12 14C11.4477 14 11 13.5523 11 13C11 12.3569 11.2959 11.8858 11.829 11.3783L11.9943 11.226L12.3374 10.9241C12.8378 10.4814 13 10.2464 13 10C13 9.44941 12.551 9 12 9C11.4872 9 11.0645 9.38604 11.0067 9.88338L11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 8.34315 10.3431 7 12 7C13.6561 7 15 8.34529 15 10C15 10.9246 14.6167 11.5416 13.836 12.2652L13.2665 12.7722L13.0279 13.0035C13.0138 13.0157 13.0061 13.0193 13.0025 13.0142L13 13.003L12.9933 13.1166ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z" fill={theme.palette.colors.corePink} />
                  </svg>
                </AvonTooltip>
              </Box>
              <Box style={language === 'ar'
                ? {
                  marginLeft: 24, flexGrow: 1, textAlign: 'left', transform: 'rotateY(180deg)',
                }
                : {
                  marginRight: 24, flexGrow: 1, textAlign: 'right', transform: 'rotateY(0)',
                }}
              >
                <IOSSwitch
                  checked={optOutEnable}
                  onChange={toggleOptOut}
                  value="toggleOptOut"
                  id="optout-switch"
                  name="optout-switch"
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box id="learnmore" textAlign="center" color={theme.palette.colors.corePink} mt="67px">
        <Typography
          weight="bold"
          style={{ cursor: 'pointer' }}
          onClick={() => redirectTo({
            type: 'learnMore', subType: null, hasFooter: false, params: null,
          })}
        >
          {learnMore}
        </Typography>
      </Box>
    </Box>
  ) : null;
};

OptOut.propTypes = {
  callApi: func.isRequired,
  redirectTo: func.isRequired,
};

export default OptOut;
